import web3Config from "../web3/web3Config.json";
const BASE_URL = ((web3Config && web3Config.EMAIL_API) || "").replace(/\/+$/, "");
let cached = null; let inflight = null;
const nowSec = () => Math.floor(Date.now() / 1000);
async function requestToken() {
  const res = await fetch(`${BASE_URL}/openapi-token`, { method: "POST" });
  const data = await res.json().catch(() => ({}));
  const token = data?.token || "";
  const expiresIn = Number(data?.expiresIn) || 3600;
  cached = { token, expiresAtSec: nowSec() + expiresIn - 60 };
  return token;
}
export const generateOpenApiTokens = async () => {
  if (cached && cached.expiresAtSec > nowSec()) return cached.token;
  if (!inflight) inflight = requestToken().finally(() => { inflight = null; });
  return inflight;
};
